import { isNil } from 'lodash';
import { useMemo } from 'react';
import { DeepPartial } from 'utility-types';

import { useData } from '@bai/data';
import { useUser } from '@bai/features/user';
import { BAITheme, TimesInMilliseconds } from '@bai/utils/types';

interface UserThemeResponse {
  BackgroundImage?: string;
  Logo?: string;
  PrimaryColor?: string;
  SecondaryColor?: string;
  TertiaryColor?: string;
}

export function useThemeOptions(): DeepPartial<BAITheme> {
  const user = useUser();
  const { data: userThemeResponse } = useData<UserThemeResponse>(
    `account/theme/user/${user?.id ?? ''}`,
    {
      enabled: !isNil(user),
      staleTime: TimesInMilliseconds.ONE_HOUR,
    },
  );
  return useMemo(() => {
    if (isNil(userThemeResponse)) return {};
    return {
      branding: {
        backgroundImage: userThemeResponse.BackgroundImage,
        logo: userThemeResponse.Logo,
        primaryColor: userThemeResponse.PrimaryColor,
        secondaryColor: userThemeResponse.SecondaryColor,
        tertiaryColor: userThemeResponse.TertiaryColor,
      },
    };
  }, [userThemeResponse]);
}
